module.exports = __webpack_public_path__ + "static/img/66-3.e271b66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/66-3.jpg
// module id = lOUX
// module chunks = 0